import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
const _hoisted_2 = {
  key: 1,
  class: "server-stats-container"
}
const _hoisted_3 = { class: "server-stat players-count" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "loader"
}
const _hoisted_6 = { class: "server-stat uptime" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "navmenu-left-container",
    "center-y": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["server-status-title", { online: !_ctx.errorMessage, offline: !!_ctx.errorMessage }])
      }, " FOnline: Reloaded Server Status ", 2),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-title" }, "Players:", -1)),
              (_ctx.onlinePlayers >= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.onlinePlayers), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-title" }, "Uptime:", -1)),
              (_ctx.serverUptime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.serverUptime), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8))
            ])
          ]))
    ]),
    _: 1
  }))
}